import type { ApiSchemas } from '@rental/contracts/client'
import type { QueryClient } from '@tanstack/react-query'
import { FINES_QUERY_KEY } from './fines'

/** One fine's query: the answer of GET and of every change, `{ fine }`. */
export function fineQueryKey(id: string) {
  return [...FINES_QUERY_KEY, 'fine', id] as const
}

/**
 * A fine changed: it shows as it now stands, and every screen that lists it
 * asks again when next shown: the register, Aperti, Today's deadlines, and
 * the bookings and customers (the one it names now, or named before a match
 * was undone).
 */
export async function fineChanged(
  queryClient: QueryClient,
  fine: ApiSchemas['StaffFine'],
): Promise<void> {
  // A read already on its way (the letter's polling) would land after the answer and put
  // back the fine as it stood before, offering again a move just made.
  await queryClient.cancelQueries({ queryKey: fineQueryKey(fine.id) })
  queryClient.setQueryData(fineQueryKey(fine.id), { fine })
  await Promise.all(
    [[...FINES_QUERY_KEY, 'list'], ['reports', 'open'], ['today'], ['booking'], ['customer']].map(
      (queryKey) => queryClient.invalidateQueries({ queryKey }),
    ),
  )
}
